import styled, { css } from 'styled-components';
import { th } from 'style/theme';

export const ChipContainer = styled.div`
  position: relative;
  display: inline-flex;
  padding: 10px 34px 10px 12px;
  border: 1px solid ${th('colors.fountainBlue-1')};
  border-radius: 16px;
  font-size: 14px;
  line-height: 1;
  background-color: ${th('colors.pickledBluewood45')};
  color: ${th('colors.fountainBlue-3')};

  ${({ readOnly }) =>
    readOnly &&
    css`
      padding-right: 12px;
    `};

  > svg {
    position: absolute;
    bottom: 7px;
    right: 10px;
    height: 19px;
    width: 19px;
    color: ${th('colors.fountainBlue-1')};
    cursor: pointer;
  }

  > img {
    position: relative;
    top: 2px;
    height: 10px;
    width: auto;
    margin-right: 5px;
  }
`;
